import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';

// Define the pages and UI components
const pages = {
  Home: 'Home',
  DesignSystem: "DesignSystem",
  UiCompo: "UiCompo",
  Login: "Login",
  Signup: "Signup",
  PasswordReset: "PasswordReset",
  Dashboard: "Dashboard", // Adding Dashboard as a protected route
  Settings: "Settings", // Adding Settings as a protected route
  Cards: "Cards",
  Favs: 'Favs',
  Features: 'Features',
  Feature: 'Feature'
  ,About: 'About'
  ,Contact: 'Contact'
  ,PrivacyPolicy: 'PrivacyPolicy'
  ,Roadmap: 'Roadmap'
  ,Price: 'Price'
  ,Counter: 'Counter' // Adding Counter page
};

// Define which routes should be protected (require authentication)
// Keep Cards public so anyone can browse user cards.
const protectedRoutes = ['Dashboard', 'Settings', 'Favs']; // Removed Counter to avoid PocketBase dependency

const uiComponents = {
  Test: 'Test',
};

// Create a default route for the Home page from pages folder
const HomeComponent = React.lazy(() => import(`../pages/Home.jsx`));

// Create routes with dynamic imports for both 'pages' and 'ui' directories
const pageRoutes = Object.keys(pages).map(page => {
  const Component = React.lazy(() => import(`../pages/${pages[page]}.jsx`));
  const isProtected = protectedRoutes.includes(page);
  
  return {
    path: `/${page.toLowerCase()}`,
    element: isProtected ? (
      <ProtectedRoute>
        <Component />
      </ProtectedRoute>
    ) : (
      <Component />
    ),
  };
});

const uiRoutes = Object.keys(uiComponents).map(component => {
  const Component = React.lazy(() => import(`../ui/atom/${uiComponents[component]}.jsx`));
  return {
    path: `/ui/atom/${component.toLowerCase()}`,
    element: <Component />,
  };
});

// Dynamic route for user pages by username
const UserPage = React.lazy(() => import(`../pages/User.jsx`));

// Admin route
const AdminPage = React.lazy(() => import(`../pages/Admin.jsx`));
const AdminTopPage = React.lazy(() => import(`../pages/AdminTop.jsx`));
const UudAnalyticsPage = React.lazy(() => import(`../pages/UudAnalytics.jsx`));
const ZilappAnalyticsPage = React.lazy(() => import(`../pages/ZilappAnalytics.jsx`));
const SchoolupAnalyticsPage = React.lazy(() => import(`../pages/SchoolupAnalytics.jsx`));

/** Profiles whose username matches a static path (e.g. "login") — see `userProfilePath`. */
const userRoutePrefixed = {
  path: '/u/:username',
  element: <UserPage />,
};

const userRoute = {
  path: '/:username',
  element: <UserPage />,
};

const adminTopRoute = {
  path: '/admin',
  element: <AdminTopPage />,
};

const adminZilupRoute = {
  path: '/admin/zilup',
  element: <AdminPage />,
};

const adminUudRoute = {
  path: '/admin/uud',
  element: <UudAnalyticsPage />,
};

const adminZilappRoute = {
  path: '/admin/zilapp',
  element: <ZilappAnalyticsPage />,
};

const adminSchoolupRoute = {
  path: '/admin/schoolup',
  element: <SchoolupAnalyticsPage />,
};

// Add the default route for Home
const defaultRoute = {
  path: '/',
  element: <HomeComponent />,
};

// Export both the default route and the dynamically generated routes from 'pages' and 'ui'
export default [
  defaultRoute,
  ...pageRoutes,
  ...uiRoutes,
  adminTopRoute,
  adminZilupRoute,
  adminUudRoute,
  adminZilappRoute,
  adminSchoolupRoute,
  userRoutePrefixed,
  userRoute,
];
